import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { Howl } from 'howler';
import { interval, Subscription } from 'rxjs';
import { ComplainHttpService } from 'src/app/http/complain-http.service';
import { AccountService } from 'src/app/services/account.service';
import { AlertComponent } from 'src/app/shared/alert/alert.component';
import { ConfirmModalComponent } from 'src/app/shared/modals/confirm-modal/confirm-modal.component';
import Fuse from 'fuse.js';

@Component({
    selector: 'app-complain-list',
    templateUrl: './complain-list.component.html',
    styles: [],
})
export class ComplainListComponent implements OnInit, OnDestroy {
    constructor(
        private activatedRoute: ActivatedRoute,
        private modalService: NgbModal,
        private complainHttpService: ComplainHttpService,
        private router: Router,
        private accountService: AccountService
    ) {}

    tempItems = [];

    items = [];

    totalItems = this.items.length;

    searchBoxControl = new FormControl();

    subscription: Subscription;

    currentHowl: any = null;

    fuse: any;

    @ViewChild('table') table: DatatableComponent;

    @ViewChild(AlertComponent) alert: AlertComponent;

    ngOnInit(): void {
        this.routeData();
        this.routeHistory();
        this.getComplainsInterval();
        this.initFuse();
    }

    routeHistory() {
        if (history.state.hasState) {
            setTimeout(() => {
                this.alert.addAlert({ type: history.state.type, message: history.state.message });
            });
        }
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.items = data.data;
            this.tempItems = data.data;
        });
    }

    initFuse() {
        const options = {
            includeScore: true,
            threshold: 0.0,
            keys: ['branch.branchName', 'title', 'status', 'createdDate', 'customerPhone'],
        };
        this.fuse = new Fuse(this.items, options);
    }

    tableFiltring(event: any) {
        const val = event.target.value.toLowerCase();
        if (!val) {
            this.items = this.tempItems;
        } else {
            const search = this.fuse.search(val);
            this.items = search.map((c: any) => c.item);
        }

        this.table.offset = 0;
    }

    confirmDelete(item: any) {
        let confirm = this.modalService.open(ConfirmModalComponent);
        confirm.componentInstance.headerLabel = 'Delete';
        confirm.componentInstance.messageLabel = 'Are you sure you want to delete this Complaint?';
        confirm.result.then(
            (result) => {
                if (result === 'ok') {
                    this.delete(item);
                }
            },
            () => {}
        );
    }

    delete(item: any) {
        this.complainHttpService.deleteComplain(item.complainsId).subscribe(() => {
            this.deleteItem(item.complainsId);
            this.alert.addAlert({ type: 'success', message: 'Complaint Deleted successfully' });
        });
    }

    deleteItem(itemId: any) {
        this.tempItems = this.tempItems.filter((c) => c.complainsId != itemId);
        this.items = this.tempItems;
    }

    mp3Notification() {
        this.currentHowl = new Howl({
            src: ['/assets/mp3/cuisine-harp_default_v2.mp3'],
            loop: true,
        });
        this.currentHowl.play();
    }

    getComplainsInterval() {
        this.subscription = interval(60000).subscribe(() => {
            this.getComplains();

            if (this.checkIfCompainsExits()) {
                this.mp3Notification();
            } else {
                if (this.currentHowl) {
                    this.currentHowl.stop();
                    this.currentHowl = null;
                }
            }
        });
    }

    getComplains() {
        this.complainHttpService.getAllComplains(this.accountService.currentUser.branchId).subscribe((data) => {
            // this.items = data.data;
            // this.tempItems = data.data;
        });
    }

    checkIfCompainsExits() {
        return this.items.some((c) => c.status === 'Open');
    }

    ngOnDestroy(): void {}
}
